<template>
  <div>
    loading指令示例，在2秒后消失，在4秒后再次显示
    <sj-card
      style="margin:10px;"
      v-sj-loading="loading"
      :sj-loading-text="loadingText"
      sj-loading-theme="3"
    >
      <div style="height: 400px;background: gray"></div>
    </sj-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      loadingText: undefined
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
    setTimeout(() => {
      this.loading = true;
      this.loadingText = "Second Loading...";
    }, 4000);
  }
};
</script>
